<template>
    <div class="company-revenue-summary">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Company Revenue Summary</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body>
                <!-- HEADER -->
                <b-card-header class="border-0">
                    <b-row></b-row>
                </b-card-header>

                <!-- SEARCH INPUT -->
                <b-col cols="12">
                    <b-row class="d-flex align-items-center">
                        <b-col cols="12" md="6" class="d-md-flex">
                            <base-input
                            label="Search"
                            v-model="searchQuery"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search..."
                            >
                            </base-input>
                            <base-input label="Date" class="mx-4">
                                <el-date-picker
                                v-model="datePicked"
                                type="month"
                                format="MMMM yyyy"
                                placeholder="Pick a month">
                                </el-date-picker>
                            </base-input>
                        </b-col>
                    </b-row>
                </b-col>

                <!-- TABLE LIST -->
                <div class="table-listings">
                    <el-table 
                        ref="multipleTable"
                        v-loading="isTableLoading"
                        :data="queriedData"
                        style="width: 100%;"
                        @selection-change="selectionChange"
                    >

                        <el-table-column
                            type="selection"
                            width="35"
                            fixed
                            class-name="double-line-label px-2"
                        ></el-table-column>
                    
                        <!-- NAME COLUMN -->
                        <el-table-column
                            label="Customer"
                            min-width="200"
                            sortable
                        >
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.customer_name }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.customer_id }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Product Details"
                            min-width="200"
                        >
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.product }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.product_detail }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.product_type }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Channel Sales"
                            min-width="100"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.channel_sales }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Lead Owner / Comm"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.lead_owner }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.lead_owner_comm | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Sales Value / Addtional SAS 3%"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.sales_value | moneyFormatter }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.additional_sas | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Total Revenue / Revenue Point"
                            min-width="150"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.total_revenue | moneyFormatter }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.total_revenue_point | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Line Up / Loan Officer Comm"
                            min-width="120"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.line_up_comm | moneyFormatter }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.loan_officer_comm | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Other Cost"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.other_cost | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="Total / Gross Profit"
                            min-width="100"
                        >
                            <template slot="header" slot-scope="scope">
                                <span class="text-break">{{ scope.column.label }}</span>
                            </template>
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.total | moneyFormatter }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.gross_profit | moneyFormatter }}
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DatePicker } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['customer_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [
                {
                    customer_id: 1001,
                    customer_name: 'Noor Aziah Binti Abdullah',
                    product: 'Nadayu801 Tower E',
                    product_detail: 'E-08-11A',
                    product_type: 'PCB',
                    channel_sales: 'PFCC',
                    lead_owner: 'Locus-T',
                    sales_value: 568327.88,
                    additional_sas: 23080.86,
                    total_revenue: 84628.82,
                    lead_owner_comm: 0,
                    line_up_comm: 0,
                    total_revenue_point: 11101.86,
                    loan_officer_comm: 200,
                    other_cost: 3000,
                    total: 14120.42,
                    gross_profit: 70509.40
                },
                {
                    customer_id: 1011,
                    customer_name: 'Raymond A/L Sivalingam',
                    product: '1st Year Premium',
                    product_detail: 'RM 600 x 27%',
                    product_type: 'Insurance',
                    channel_sales: 'FFH',
                    lead_owner: 'ONE WSM',
                    sales_value: 600,
                    additional_sas: 0,
                    total_revenue: 162,
                    lead_owner_comm: 0,
                    line_up_comm: 0,
                    total_revenue_point: 162,
                    loan_officer_comm: 0,
                    other_cost: 0,
                    total: 134.46,
                    gross_profit: 27.54
                }
            ],
            datePicked: ''
        }
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
    }
}
</script>